import { render } from "./index.vue?vue&type=template&id=3efa1158"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./homepage.css?vue&type=style&index=0&lang=css"

import exportComponent from "/home/mali/APP_FCCBookingApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__